// extracted by mini-css-extract-plugin
export default {"summary":"RecursiveAccordion_summary__56-4G","title":"RecursiveAccordion_title__kfaAn"};